import axiosInstance, { ApiKeys, getApiUrl } from '@cp/utils/ApiHelper';
import { reasons } from '@cp/src/components/sidebar/constants/constants';

enum ActivityStatus {
  ACTIVE = 'ACTIVE',
  ON_BREAK = 'ON_BREAK'
}

const setAgentAvailability = (status: boolean, breakReason: string) => {
  const url = getApiUrl(ApiKeys.AGENT_ONLINE_OFFLINE_STATUS);
  return axiosInstance.post(url, {
    activityStatus: status ? ActivityStatus.ACTIVE : ActivityStatus.ON_BREAK,
    breakReason: reasons.find(reason => reason.label === breakReason)?.key
  });
};

export default setAgentAvailability;
